<template>
  <v-dialog
    v-model="show"
  >
    <v-card
      :light="! dark"
      :color="color"
      shaped
    >
      <v-toolbar
        flat
        :color="color"
      >
        <v-spacer />
        <v-btn
          color="primary"
          icon
          @click="show = false"
        >
          <v-icon v-text="icons.close" />
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <slot />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      UsesIcons,
    ],

    props: {
      value: {
        required: true,
        type: Boolean,
      },
      dark: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    computed: {
      show: {
        get () {
          return this.value
        },
        set (v) {
          this.$emit('input', v)
        },
      },
      color () {
        return this.dark ? 'secondary' : 'white'
      },
    },
  }
</script>
